import { render, staticRenderFns } from "./PointGmoney.vue?vue&type=template&id=551f6284"
import script from "./PointGmoney.vue?vue&type=script&lang=js"
export * from "./PointGmoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports